import {
  DtoBase,
  Enums,
  TenantModels,
  UIDtoFactory,
  UserEnums,
  UserModels,
} from '@project44-models/iam-gateway';

import { UnauthorizedTenantAgnosticRolesUserException } from '../errors/UnauthorizedTenantAgnosticRoles.user.exception';
import { IUserCreationForm } from '../interfaces';
import { userCreationSchema } from '../schemas/userCreation.schema';

export class UserMapper {
  public static toUserWithTenantAgnosticRoles(
    user: DtoBase<UserModels.UserViewModel>,
  ): DtoBase<UserModels.UserViewModel> {
    if (this.isUserCandidateForTenantAgnosticRoles(user)) {
      return UIDtoFactory.create(Enums.UiDtoFactoryEnum.USER, user.toJSON());
    }

    UnauthorizedTenantAgnosticRolesUserException.throw(
      user.toSerializedModel(),
    );
  }

  public static isUserCandidateForTenantAgnosticRoles(
    user: DtoBase<UserModels.UserViewModel>,
  ): boolean {
    const userType: UserEnums.UserTypeEnum = user.source.getUserType();

    switch (true) {
      case userType === UserEnums.UserTypeEnum.CLIENT_APPLICATION_USER:
        return true;
      case user.source.getUsername().endsWith('@project44.com'):
        return new Array<boolean>(
          userType !== UserEnums.UserTypeEnum.SYSTEM_USER,
          userType !== UserEnums.UserTypeEnum.CUSTOMER_INTEGRATION_USER,
        ).every((value) => value);
      default:
        return false;
    }
  }

  public static toUserCreationViewModel(payload: {
    userFormCreator: IUserCreationForm;
    tenant: DtoBase<TenantModels.TenantViewModel>;
  }): DtoBase<UserModels.UserCreationViewModel> {
    const userFormCreator = userCreationSchema.validateSync(
      payload.userFormCreator,
      {
        abortEarly: false,
        stripUnknown: true,
      },
    );

    const { password, phoneNumber } = userFormCreator;

    const userCreatorPayload: UserModels.UserCreationViewModel = {
      familyName: userFormCreator.familyName,
      givenName: userFormCreator.givenName,
      locale: 'en-us',
      password: password.length === 0 ? null : password,
      tenantId: payload.tenant.source.getTenantId(),
      tenantUuid: payload.tenant.source.getTenantUuid(),
      username: userFormCreator.username,
      userType: userFormCreator.userType,
      phoneNumber: phoneNumber.length === 0 ? null : phoneNumber,
    };

    return UIDtoFactory.create(
      Enums.UiDtoFactoryEnum.USER_CREATION,
      userCreatorPayload,
    );
  }
}
